/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
/* Styles */
import styles from "@lb/Sections/aboutDevi/styles.module.css"
/* Services */

const AboutDeviSlide17 = () => {
  return (
    <Box
      background={`#000 url(${config.imgPath}/d/46272/1684475590-ib_secion17bg.jpg) no-repeat center top`}
      bgSize={{ base: '70rem', lg: 'cover' }}
      bgColor="#000"
      className={styles.section17Bg}
    ></Box>
  );
};
export default AboutDeviSlide17;
